import * as React from "react";

import { Utilities } from "shared/utilities";

const useAzureAiStatus = () => {
    const [azureAiStatus, setAzureAiStatus] = React.useState<AzureAiStatus>();

    const isExpectedResponseStatus = (status: number) => Object.values(AzureAiStatus).includes(status);

    React.useEffect(() => {
        const fetchIsAssistantEnabled = async () => {
            let status;

            try {
                const res = await Utilities.getFetchWithoutResultParsing(`${Utilities.getUrlBase()}api/azureai/is-enabled`);
                if (isExpectedResponseStatus(res.status)) {
                    status = res.status;
                }
                // eslint-disable-next-line no-empty
            } catch (_) { }

            if (status !== undefined) {
                setAzureAiStatus(status);
            } else {
                Utilities.toastError('Failed to fetch if Frends assistant is enabled.');
            }
        }

        fetchIsAssistantEnabled();
    }, []);

    return azureAiStatus;
};

export default useAzureAiStatus;

export enum AzureAiStatus {
    Disabled = 503,
    QuotaExceeded = 403,
    Enabled = 200,
}